import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import AuthProvider from "./provider/AuthProvider";
import LadderProvider from "./provider/LadderProvider";

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <LadderProvider>
        <App />
      </LadderProvider>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
